import ReactIcon from './ReactIcon.jsx';

export default ReactIcon;
